import { getRequest, postRequest, patchRequest } from '../utils/axios';
import { buildUrlParams } from '../utils/urls';

export const patternsService = {
  getPatternCategories: (onSuccess, onError) => {
    getRequest(
      '/api/v1/pattern-categories/',
      (response) => {
        if (onSuccess) {
          return onSuccess(response);
        }
      },
      (error, response) => {
        if (onError) {
          return onError(error, response);
        }
      }
    );
  },

  getPatterns: (params, onSuccess, onError) => {
    const urlParams = buildUrlParams(params);
    const url = `/api/v1/audience-patterns/${urlParams}`;

    getRequest(
      url,
      (response) => {
        if (onSuccess) {
          return onSuccess(response);
        }
      },
      (error, response) => {
        if (onError) {
          return onError(error, response);
        }
      }
    );
  },

  analyzePatternAnalysis: (payload, onSuccess, onError) => {
    postRequest(
      '/api/v1/audience-patterns/analyze/',
      payload,
      (response) => onSuccess?.(response),
      (error) => onError?.(error)
    );
  },
};
